import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import products from './products'
import simphongthuy from './simphongthuy'
import shop from './shop'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    products,
    simphongthuy,
    shop
  },
  strict: process.env.DEV,
})
